export default class OutlookUserProfile {
  constructor(office) {
    this.office = office
  }

  get userProfile() {
    return this.office.context.mailbox.userProfile
  }

  get emailAddress() {
    return this.userProfile.emailAddress
  }
}
